export default __webpack_public_path__ + "static/media/clock.82737e37.svg";